import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import { concat, Observable, of } from 'rxjs';

import { AppPublicProjectView } from './app-public-project-view.entity';

@Component({
	selector: 'app-public-project-view',
	templateUrl: 'app-public-project-view.component.html',
	styleUrls: ['app-public-project-view.component.scss'],
	inputs: ['project'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppPublicProjectViewComponent
	extends DcBaseComponent
	implements OnInit
{
	public vo$!: Observable<{
		project: AppPublicProjectView | null;
	}>;

	public constructor() {
		super();
		this.cmpId = 'public-project';
	}

	public ngOnInit(): void {
		super.ngOnInit();

		this.vo$ = combineAll({
			project: concat(
				of(null),
				this.toObservable<AppPublicProjectView>('project')
			),
		});
	}
}
